import type { OrganKind } from "./types";

export interface OrganInfo {
  name: string;
  funktion: string;
  regeln: string[];
}

export const ORGAN_INFO: Record<OrganKind, OrganInfo> = {
  mund: {
    name: "Mund",
    funktion: "Speichelamylase spaltet Stärke direkt zu Kohlenhydraten.",
    regeln: ["🍞 Brot → 🟨 KH"],
  },
  magen: {
    name: "Magen",
    funktion: "Zerkleinert und sauert die Nahrung an (Salzsäure, Pepsin).",
    regeln: ["🥩 Fleisch → 🟫 Fleisch-Brei"],
  },
  speiseroehre: {
    name: "Speiseröhre",
    funktion: "Transportiert Nahrung per Peristaltik weiter.",
    regeln: ["↕ Fördert Partikel entlang der Rotation"],
  },
  leber: {
    name: "Leber",
    funktion: "Galle emulgiert Fett zu kleinen Tropfen.",
    regeln: ["💧 Öl → 🟡 Öltropfen"],
  },
  pankreas: {
    name: "Bauchspeicheldrüse",
    funktion: "Enzyme spalten Brei und Tropfen zu Endprodukten.",
    regeln: ["🟫 Fleisch-Brei → 🟥 Protein", "🟡 Öltropfen → 🟨 Fett"],
  },
  darm: {
    name: "Darm",
    funktion: "Absorbiert die Endprodukte – das Spielziel.",
    regeln: ["🎯 Absorbiert: KH, Protein, Fett"],
  },
  ramp: {
    name: "Bauchwand",
    funktion: "Lenkt fallende Partikel. Unbegrenzt verfügbar.",
    regeln: ["↘ Umlenkung"],
  },
};
